import React from "react";

const Newsletter = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <section className="newsletter-section">
      <div className="container">
        <div className="newsletter-card">
          <div className="nl-text">
            <h2>Newsletter</h2>
            <p>Recevez nos offres et nos nouveautés directement par email.</p>
          </div>
          <form onSubmit={handleSubmit} className="nl-form">
            <input type="email" placeholder="Votre email professionnel" aria-label="Votre email" required />
            <button type="submit">S'inscrire</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
